<template>
	<!-- 注册弹框 -->
	<div class="register" @click="close()">
		<div class="box share_Up_down animate__animated animate__zoomIn" @click.stop>
			<div class="title ">
				<p></p>
				<span>欢迎联系我们</span>
				<p></p>
			</div>
			<div class="wrap">
				<div class="info">
					<ul>
						<li>
							<input type="text" v-model="name" placeholder="姓名" />
						</li>
						<li>
							<input type="text"  v-model="age" placeholder="年龄" />
						</li>
						<li>
							<input type="text"  v-model="city" placeholder="代理城市" />
						</li>
					</ul>
				</div>
				
				<div class="info">
					<ul>
						<li>
							<input type="text"  v-model="phone" placeholder="联系电话" />
						</li>
						<li>
							<input type="text"  v-model="occupation" placeholder="职业" />
						</li>
						<li>
							<input type="text"  v-model="education" placeholder="学历" />
						</li>
					</ul>
				</div>
			</div>
			<div class="marks">
				<div class="ps">
					<div class="pic"></div>
					<span>代理优势：（是否拥有团队，是否拥有本地汽服资源，是否具备商 务运营能力，预计投资额度或其他）</span>
				</div>
				<div class="text_box">
					<textarea v-model="advantage"></textarea>
				</div>
			</div>
			<div class="btn" @click="add">
				确认提交
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				name:'',							//姓名
				age:'',								//年龄
				city:'',							//代理城市
				phone:'',							//联系电话
				occupation:'',						//职业
				education:'',						//学历
				advantage:'',						//优势
			}
		},
		methods:{
			add(){
				let obj = {
					name:this.name,								//姓名
					age:this.age,								//年龄
					city:this.agent_city,						//代理城市
					mobile:this.phone,							//联系电话
					occupation:this.professional,				//职业
					education:this.education,					//学历
					advantage:this.advantage					//优势
				}
				this.$emit('add',obj)
			},
			// 
			close(){
				this.$emit('change')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.register{
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		position: fixed;
		top: 0;
		z-index: 999;
		
		.box{
			width: 6rem;
			height: 7rem;
			background: #FFFFFF;
			border-radius: 0.2rem;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			
			.title{
				width: 3.2rem;
				height: 0.17rem;
				display: flex;
				align-items: center;
				justify-content: space-around;
				margin-top: 0.36rem;
				p{
					width: 0.5rem;
					height: 0.02rem;
					background: linear-gradient(-90deg, #FF7300, #FF9729);
				}
				span{
					font-size: 0.18rem;
					color: #333333;
				}
			}
			.wrap{
				width: 100%;
				display: flex;
				justify-content: space-around;
			}
			.info{
				width: 2.09rem;
				min-height: 2.18rem;
				// background-color: #0000FF;
				margin-top: 0.52rem;
				
				li{
					width: 2.09rem;
					height: 0.19rem;
					padding: 0.14rem 0;
					border-bottom: 0.01rem solid #CCCCCC;
					display: flex;
					background: url(../../../public/images/name.png) no-repeat left center;
					background-size: 0.17rem 0.19rem;
					
					input{
						width:1.6rem;
						height: 0.19rem;
						font-size: 0.16rem;
						line-height: 0.19rem;
						border: none;
						margin-left: 0.37rem;
					}
				}
				li:nth-child(2){
					background: url(../../../public/images/age.png) no-repeat left center;
					background-size: 0.2rem 0.2rem;
					margin-top: 0.4rem;
				}
				li:nth-child(3){
					background: url(../../../public/images/city.png) no-repeat left center;
					background-size: 0.19rem 0.19rem;
					margin-top: 0.4rem;
				}
				li:nth-child(6){
					background: url(../../../public/images/phone2.png) no-repeat left center;
					background-size: 0.15rem 0.2rem;
					margin-top: 0.4rem;
				}
			}
			.info:nth-child(2){
				li{
					background: url(../../../public/images/phone2.png) no-repeat left center;
					background-size: 0.15rem 0.2rem;
				}
				li:nth-child(2){
					background: url(../../../public/images/occupation.png) no-repeat left center;
					background-size: 0.2rem 0.18rem;
					margin-top: 0.4rem;
				}
				li:nth-child(3){
					background: url(../../../public/images/education.png) no-repeat left center;
					background-size: 0.2rem 0.21rem;
					margin-top: 0.4rem;
				}
				
			}
			.marks{
				width: 5.2rem;
				font-size: 0.16rem;
				color: #999999;
				margin-top: 0.48rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				
					
				.ps{
					width: 5.2rem;
					display: flex;
					
					.pic{
						width: 0.21rem;
						height: 0.2rem;
						margin-right: 0.14rem;
						background: url(../../../public/images/laugh.png) no-repeat left center;
						background-size: 0.21rem 0.2rem;
					}
					span{
						width: 4.54rem;
						line-height: 0.18rem;
					}
				}
				.text_box{
					width: 5.2rem;
					height: 1.34rem;
					border: 0.01rem solid #CCCCCC;
					margin-top: 0.13rem;
					display: flex;
					justify-content: center;
					align-items: center;
					
					textarea{
						width: 4.87rem;
						height: 1rem;
						border: none;
						resize: none;
					}
				}
			}
			.btn{
				width: 3.2rem;
				height: 0.5rem;
				background: linear-gradient(-90deg, #FF7300, #FF9729);
				border-radius: 0.25rem;
				font-size: 0.16rem;
				line-height: 0.5rem;
				text-align: center;
				color: #fff;
				margin-top: 0.4rem;
			}
		}
	}
</style>
